<template>
  <div style="height: 100px; background: #fff">
    <div
      style="
        box-shadow: 0px 7px 9px 0px rgba(110, 110, 110, 0.1);
        height: 100px;
        position: relative;
        z-index: 999;
        background: #fff;
      "
    >
      <div
        class="controlWdth"
        style="    display: flex;
    justify-content: space-between;"
      >
        <!-- <div class="sorTtitle theme-bg float-left">
      <span class="float-left theme-bg theme-col navall">

        <span>
          <i class="iconfont iconfenlei" style="vertical-align:baseline;font-size: 12px"></i>
        </span>
        <span>商品分类</span>
      </span>
      <ul class="navlist">
        <router-link
          :to="{name:'Goodslist',query:{classid:item.id,stype:1}}"
          v-for="item in classesdatas"
          :key="item.id"
        >
          <li>{{item.name}}</li>
        </router-link>
      </ul>
    </div> -->
        <div
          class="common_nav_log float-left"
          style="
    text-align: left;"
        >
          <router-link to="/" id="logo" style="display:inline-block;">
            <div ref="logo">
              <img
                :src="logourl"
                onerror="src='/static/img/logo.png'"
                style="max-width:200px;max-height:60px;    width: auto;"
              />
              <div style="clear:both;"></div>
            </div>
          </router-link>
        </div>
        <div
          class="nav float-left nav3 "
          v-if="$store.state.webInfo.base_conf.is_nav == 1"
        >
          <swiper :options="swiperOptionsbanner" ref="mySwiper">
            <swiper-slide>
              <span
                @click="go('HOME')"
                :class="$route.path == '/index' ? 'theme-col' : ''"
                >首页</span
              >
            </swiper-slide>
            <swiper-slide>
              <span
                style="position: relative"
                @mouseenter="show1()"
                @mouseleave="hidden()"
                >{{ $common.cardName().type ? '商品':'礼品' }}分类
                <div
                  style="
                    position: absolute;
                    background: none;
                    height: 30px;
                    width: 100%;
                    left: 0px;
                    z-index: -1;
                  "
                ></div>
              </span>
            </swiper-slide>
            <swiper-slide v-for="item in list" :key="item.id">
              <span
                :class="checkPath(item.url, item.name) ? 'theme-col' : ''"
                @click="go(item.url, item.name)"
                @mouseenter="navData(item.url)"
                @mouseleave="evtHeaderLeave()"
                >{{ item.name }}</span
              >
            </swiper-slide>
          </swiper>

          <!-- <ul>
            <li style="    display: inline-block; float:auto;">
              <span
                @click="go('HOME')"
                :class="$route.path == '/index' ? 'theme-col' : ''"
                >首页</span
              >
            </li>
            <li
              class="navall"
              style="   float:auto;  display: inline-block;"
              @mouseenter="show1()"
              @mouseleave="hidden()"
            >
              <span style="position: relative"
                >礼品分类
                <div
                  style="
                    position: absolute;
                    background: none;
                    height: 30px;
                    width: 100%;
                    left: 0px;
                    z-index: -1;
                  "
                ></div>
              </span>
            </li>

            <li
              v-for="item in list"
              :key="item.id"
              @mouseenter="navData(item.url)"
              @mouseleave="evtHeaderLeave()"
              style="    display: inline-block; float:auto;"
            >

              <span
                :class="checkPath(item.url, item.name) ? 'theme-col' : ''"
                @click="go(item.url, item.name)"
                >{{ item.name }}</span
              >
            </li>
          </ul> -->
        </div>
        <div
          style="float: right"
          v-if="$store.state.webInfo.base_conf.is_home_search == 1"
          :class="list.length > 7 ? 'nav1' : ''"
        >
          <div class="common_nav_search float-left">
            <input
              @keyup.enter="onSearch"
              v-model="search_keywords"
              type="text"
              id="search"
              class=""
              placeholder="搜索您想要的商品"
            />
            <i
              class="layui-icon iconfont iconfangdajing"
              @click="onSearch"
              style="
position:absolute;z-index:10;
                font-size: 16px;
                font-weight: bold;
                position: absolute;
                color: #e23130;
                right: 0;
                width: 46px;
                line-height: 46px;
                height: 46px;
              "
            ></i>
            <!-- <button @click="onSearch" class="theme-bg theme-bd common_nav_search_btn">搜索</button> -->
          </div>
        </div>
      </div>
      <transition name="fadein">
        <div
          class="navzhuanti"
          v-show="headerStatus"
          @mouseenter="evtHeaderEnter()"
          @mouseleave="evtHeaderLeave()"
        >
          <ul class="">
            <li v-for="(item, index) in navdatas" :key="index">
              <router-link
                :to="{ name: 'Detail', params: { id: item.id || item.itemId } }"
              >
                <div>
                  <img
                    v-lazy="item.image"
                    onerror="src='/static/imgout2.png'"
                    style="width: 160px; height: 160px"
                  />
                </div>
                <p class="zhuantitle">{{ item.name }}{{ item.itemName }}</p>
                <p class="zhaungtijf">
                  <span v-if="item.price_points || item.point">{{ item.price_points }}{{ item.point }}{{$store.state.name}}</span>
                  <span v-if="item.price_cash">
                    <span v-if="item.price_points || item.point">+</span>
                    {{ item.price_cash }}元
                  </span>
                </p>
              </router-link>
            </li>
          </ul>
        </div>
      </transition>
      <div class="fl" @mouseenter="show1()" @mouseleave="hidden()">
        <ul class="navlist" id="nablist" v-show="show">
          <li
            v-for="(item, index) in classesdatas"
            :key="item.id"
            style="margin-left:0px; padding:0px;"
          >
            <router-link
              :to="{
                name: 'Goodslist',
                query: { classid: item.id }
              }"
              ><img
                v-lazy="item.image"
                onerror="src='/static/imgout2.png'"
                lazy
              />
              <span>{{ item.name }} </span></router-link
            >
          </li>
        </ul>
      </div>
    </div>
    <!-- <ul
      class="navlist"
      id="nablist"
      v-show="showNav"
      style=""
      @mouseenter="showNav1"
      @mouseleave="showNav1"
    >
      <li v-for="(item, index) in classesdatas" :key="item.id">
        <router-link
          :to="{ name: 'Goodslist', query: { classid: item.id, stype: 1 } }"
          ><img v-lazy="item.image" onerror="src='/static/imgout2.png'" lazy />
          <span>{{ item.name }} </span></router-link
        >
      </li>
    </ul> -->
  </div>
</template>
<script>
import { swiper, swiperSlide, directive } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
export default {
  data() {
    return {
      logoWidth: "",
      show: false,
      classesdatas: this.$store.state.classesdatas,
      list: [],
      navdatas: [],
      navdatas1: [],
      navdatas2: [],
      classids: [],
      search_keywords: "",
      logourl: this.$store.state.webInfo.logo_pc,
      showNav: false,
      headerStatus: false,
      tids: null,
      tids12: null,
      swiperOptionsbanner: {
        slidesPerView: "auto"

        // loop:true,
      }
    };
  },
  components: {
    swiper,
    swiperSlide
  },
  methods: {
    getWidth() {
      let tt = this.$refs.logo;
      setTimeout(() => {
        console.log(tt.getElementsByTagName("img")[0].offsetWidth);
      }, 100);
      if (this.logourl) {
        this.logoWidth =
          770 + 190 - tt.getElementsByTagName("img")[0].offsetWidth;
      }
      // console.log(tt.getElementsByTagName("img")[0]).style.width;
    },
    show1() {
      this.show = true;
      clearTimeout(this.tids12);
    },
    hidden() {
      let self = this;
      this.tids12 = setTimeout(function() {
        self.show = false;
      }, 200);
    },
    navData(url) {
      if (url === "Mall/Member/Member/collect") {
        this.navdatas = this.navdatas1;
        this.headerStatus = this.navdatas1.length > 0;
      } else if (url === "Mall/Product/Product/index") {
        this.navdatas = this.navdatas3;
        this.headerStatus = this.navdatas3.length > 0;
      } else if (url === "Mall/Product/Product/iExchange") {
        this.navdatas = this.navdatas2;
        this.headerStatus = this.navdatas2.length > 0;
      } else if (url === "Mall/Member/Member/index") {
        this.headerStatus = false;
      }
      // console.log(this.navdatas)
      //  console.log(this.navdatas1)
      //   console.log(this.navdatas2)
      clearTimeout(this.tids);
    },
    tt(url, name) {
      // console.log(this.tids)
      // this.headerStatus = true;
      // this.navdatas=[];
      if (
        this.$store.state.user_id == "" ||
        this.$store.state.user_id == "null"
      ) {
        if (url === "Mall/Member/Member/collect") {
          this.headerStatus = false;
        }
        if (url === "Mall/Product/Product/iExchange") {
          this.headerStatus = false;
        }
        if (url === "Mall/Product/Product/index") {
          this.headerStatus = true;
          this.navdatas = [];
          this.$api.get(
            "product/goodslist",
            {
              id_example: this.$store.state.id_example,
              clas_id: "", //分类ID
              stype: 1, //分类ID
              sale: " ", //销量
              price: " ", //价格
              add_time: "", //时间
              point_pre: " ", //区间前置
              point_post: " ", //区间后置
              name: " ", //产品名称
              page: 1, //页码
              count: 6 //每页默认显示数量
            },
            res => {
              if (res.data.code == 100) {
                this.navdatas = res.data.data.list;
                // console.log(this.headerStatus);
                // this.allpage = res.data.data.total_page;
              }
            }
          );
        }
      } else {
        if (url === "Mall/Product/Product/index") {
          this.headerStatus = true;
          this.navdatas = [];
          this.$api.get(
            "product/goodslist",
            {
              id_example: this.$store.state.id_example,
              clas_id: "", //分类ID
              stype: 1, //分类ID
              sale: " ", //销量
              price: " ", //价格
              add_time: "", //时间
              point_pre: " ", //区间前置
              point_post: " ", //区间后置
              name: " ", //产品名称
              page: 1, //页码
              count: 6 //每页默认显示数量
            },
            res => {
              if (res.data.code == 100) {
                this.navdatas = res.data.data.list;
                //this.navdatas1 = res.data.data.list;
                // console.log(this.headerStatus);
                // this.allpage = res.data.data.total_page;
              }
            }
          );
        } else if (url === "Mall/Member/Member/collect") {
          this.navdatas = [];
          this.headerStatus = true;
          this.$api.get(
            "user/collection/p_list",
            {
              id_example: this.$store.state.id_example,
              token_user: this.$store.state.user_id
              // pageIndex: this.page
            },
            res => {
              if (res.data.code == 100) {
                // this.navdatas = res.data.data.list;
                this.navdatas1 = res.data.data.list;
                console.log(this.headerStatus);
                // if(this.navdatas.length==0){
                //   this.headerStatus=false;
                // }else{
                //   this.headerStatus=true;
                // }

                // this.count = res.data.data.count * 5;
                // if (res.data.data.list == "" && res.data.data.count != 0) {
                //   this.page = 1;
                //   this.getcollect();
                // }
              } else if (res.data.code == -101) {
                // this.navdatas = [];
                // this.evtHeaderLeave()
              }
            }
          );
        } else if (url === "Mall/Product/Product/iExchange") {
          this.navdatas = [];
          this.headerStatus = true;
          this.$api.get(
            "product/goodslist",
            {
              id_example: this.$store.state.id_example,
              clas_id: "", //分类ID
              stype: 1, //分类ID
              sale: " ", //销量
              price: " ", //价格
              add_time: "", //时间
              point_pre: " ", //区间前置
              point_post: " ", //区间后置
              name: " ", //产品名称
              page: 1, //页码
              count: 6 //每页默认显示数量
            },
            res => {
              if (res.data.code == 100) {
                this.navdatas2 = res.data.data.list;
                this.headerStatus = true;
                this.allpage = res.data.data.total_page;
                // this.loading = false;
                //   var arr=''
                // for (let i = 0; i < res.data.data.list.length; i++) {
                //   if (res.data.data.list[i].source == 1) {
                //     arr+=res.data.data.list[i].id_spro+','
                //   }
                // }
                this.checksocket(arr);
              }
            },
            err => {
              this.$router.push({ name: "Overtime" });
            }
          );
        } else if (url === "Mall/Member/Member/index") {
          this.navdatas = [];
          this.headerStatus = false;
        }
      }

      clearTimeout(this.tids);
    },
    getnavdatas() {
      if (
        this.$store.state.user_id == "" ||
        this.$store.state.user_id == "null"
      ) {
        //  this.headerStatus=true;
        this.navdatas = [];
        this.navdatas1 = [];
        this.navdatas2 = [];
        this.$api.get(
          "product/goodslist",
          {
            id_example: this.$store.state.id_example,
            clas_id: "", //分类ID
            stype: 1, //分类ID
            sale: " ", //销量
            price: " ", //价格
            add_time: "", //时间
            point_pre: " ", //区间前置
            point_post: " ", //区间后置
            name: " ", //产品名称
            page: 1, //页码
            count: 6 //每页默认显示数量
          },
          res => {
            if (res.data.code == 100) {
              this.navdatas3 = res.data.data.list;
            }
          }
        );
      } else {
        this.$api.get(
          "product/goodslist",
          {
            id_example: this.$store.state.id_example,
            clas_id: "", //分类ID
            stype: 1, //分类ID
            sale: " ", //销量
            price: " ", //价格
            add_time: "", //时间
            point_pre: " ", //区间前置
            point_post: " ", //区间后置
            name: " ", //产品名称
            page: 1, //页码
            count: 6 //每页默认显示数量
          },
          res => {
            if (res.data.code == 100) {
              this.navdatas3 = res.data.data.list;
            }
          }
        );

        //  this.headerStatus=true;
        this.$api.get(
          "user/collection/p_list",
          {
            id_example: this.$store.state.id_example,
            token_user: this.$store.state.user_id
            // pageIndex: this.page
          },
          res => {
            if (res.data.code == 100) {
              // this.navdatas = res.data.data.list;
              this.navdatas1 = res.data.data.list;
              // if(this.navdatas.length==0){
              //   this.headerStatus=false;
              // }else{
              //   this.headerStatus=true;
              // }

              // this.count = res.data.data.count * 5;
              // if (res.data.data.list == "" && res.data.data.count != 0) {
              //   this.page = 1;
              //   this.getcollect();
              // }
            } else if (res.data.code == -101) {
              // this.navdatas = [];
              // this.evtHeaderLeave()
            }
          }
        );

        this.$api.get(
          "product/goodslist",
          {
            id_example: this.$store.state.id_example,
            clas_id: "", //分类ID
            stype: 1, //分类ID
            sale: " ", //销量
            price: " ", //价格
            add_time: "", //时间
            point_pre: " ", //区间前置
            point_post: " ", //区间后置
            name: " ", //产品名称
            page: 1, //页码
            count: 6 //每页默认显示数量
          },
          res => {
            if (res.data.code == 100) {
              this.navdatas2 = res.data.data.list;
              //  this.headerStatus = true;
              this.allpage = res.data.data.total_page;
              // this.loading = false;
              //   var arr=''
              // for (let i = 0; i < res.data.data.list.length; i++) {
              //   if (res.data.data.list[i].source == 1) {
              //     arr+=res.data.data.list[i].id_spro+','
              //   }
              // }
              this.checksocket(arr);
            }
          }
        );

        this.navdatas = [];
      }

      clearTimeout(this.tids);
    },
    evtHeaderEnter() {
      this.headerStatus = true;
      clearTimeout(this.tids);
    },
    evtHeaderLeave() {
      let self = this;
      this.tids = setTimeout(function() {
        self.headerStatus = false;
      }, 200);
    },
    //获取列表
    getData() {
      this.$api.get(
        "sys/typelist",
        {
          id_example: this.$store.state.id_example,
          terminal: "pc"
        },
        res => {
          if (res.data.code == 100) {
            this.classesdatas = res.data.data;
          }
        }
      );
    },
    showNav1() {
      this.showNav = !this.showNav;
    },
    //获取导航栏
    channel: function() {
      this.$api.get(
        "sys/channel",
        { id_example: this.$store.state.id_example, terminal: "pc" },
        res => {
          if (res.data.code == 100) {
            if (
              res.data.data.location_url != undefined &&
              res.data.data.location_url != null
            ) {
              window.location.href = res.data.data.location_url;
              return false;
            }
            this.list = res.data.data;
            for (var i in this.list) {
              if (this.list[i].url.indexOf("classid") != -1) {
                this.classids.push(this.splitclassid(this.list[i].url));
              }
            }
          }
        }
      );
    },
    //路由跳转
    go: function(url, name) {
      console.log("url", url);
      switch (url) {
        case "Mall/Product/Product/index":
          this.$router.push({ path: "/goodsList" });
          break;
        case "Mall/Member/Member/collect":
          this.$router.push({ path: "/user/mycollect" });
          break;
        case "Mall/Product/Product/iExchange":
          if (this.$store.state.user_id != "null") {
            this.$router.push({ path: "/goodsList", query: { mypoint: 1 } });
          } else {
            this.$confirm("你还未登录是否登录", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
              .then(() => {
                this.$router.push({ name: "Login", params: { type: 1 } });
              })
              .catch(() => {});
          }
          break;
        case "Mall/Member/Member/index":
          this.$router.push({ path: "/user" });
          break;
        case "HOME":
          this.$router.push({ path: "/index" });
          break;
        default:
          window.location.href = url;
          break;
      }
    },
    checkPath(url, name) {
      var r = this.$route;
      switch (url) {
        case "Mall/Product/Product/index":
          var classid = r.query.classid;
          if (r.path == "/goodsList" && this.isEmpty(r.query)) {
            return true;
          } else if (r.path == "/goodslist") {
            return !this.isExist(classid, this.classids);
          }
          break;
        case "Mall/Member/Member/collect":
          if (r.path == "/user/mycollect") {
            return true;
          }
          break;
        case "Mall/Product/Product/iExchange":
          if (r.query.mypoint == 1) {
            return true;
          }
          break;
        case "Mall/Member/Member/index":
          if (
            r.path != "/user/mycollect" &&
            /\/user\/[^\s]+$/.test(this.$route.path)
          ) {
            return true;
          }
          break;
        default:
          var classid = this.splitclassid(url);
          if ("" + r.query.classid == classid) {
            return true;
          }
          break;
      }

      return false;
    },
    mypoint: function() {
      if (this.$store.state.userinfo != "") {
        this.$router.push({ path: "/goodslist", query: { mypoint: 1 } });
      } else {
        this.$confirm("你还未登录是否登录", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.$router.push({ name: "Login", params: { type: 1 } });
          })
          .catch(() => {});
      }
    },
    onSearch() {
      this.$router.push({
        name: "Goodslist",
        query: { keyword: this.search_keywords }
      });
    },
    isEmpty(obj) {
      for (var key in obj) {
        return false;
      }
      return true;
    },
    isExist(id, arr) {
      for (var index in arr) {
        if (arr[index] == id) {
          return true;
        }
      }
      return false;
    },
    splitclassid(url) {
      var classid = this.getQueryString("classid", url);
      return classid;
    },
    getQueryString(name, url) {
      var reg = /([^?&=]+)=([^?&=]+)/g,
        obj = {},
        str = url;
      url.replace(reg, function() {
        obj[arguments[1]] = arguments[2];
      });
      for (var keyName in obj) {
        if (keyName == name) {
          return obj[keyName];
          // break;
        }
      }
    }
  },
  mounted() {
    this.channel();
    this.classesdatas = this.$store.state.classesdatas;
    this.getData();
    this.getnavdatas();
    this.$nextTick(() => {
      // this.getWidth();
    });

    // window.onload = function() {
    //   var imgs = document.getElementById("imgs");

    //   this.getWidth();
    // };
  }
};
</script>

<style lang="less" scoped>
.nav3 {
  // width: 770px;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: overlay;
  overflow-y: hidden;
}
.swiper-slide {
  width: 300px; /*设为固定值*/
  width: auto; /*根据内容调整宽度*/
  span {
    padding: 0px 15px;
    font-size: 16px;
  }
}
.controlWdth {
  height: 100px;
  height: 57px;
  padding-top: 23px;
  // position: relative;
}

.navzhuanti {
  // transition: all .3s ease-in;

  opacity: 1;
  overflow: hidden;
  height: 256px;
  box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;

  position: absolute;
  top: 100px;
  background: #fff;
  width: 100%;
  left: 0;

  // transition: display 0.25s ease;
  z-index: 9;
  padding-bottom: 24px;
  padding-top: 16px;
  border-top: solid 1px #e5e5e5;
  // box-shadow: 0px 3px 12px 0px rgba(110, 110, 110, 0.42);
  box-shadow: 0px 9px 8px 0px rgba(110, 110, 110, 0.12);
  ul {
    width: 1200px;
    position: relative;
    margin: 0 auto;
    //   display: flex;
    // justify-content: space-between;
    li:first-child {
      margin-left: 0px !important;
    }
    li:after {
      content: "";
      width: 1px;
      height: 100px;
      background: #e5e5e5;
      position: absolute;
      top: 30px;
      right: 0px;
    }
    li:last-child {
      &:after {
        width: 0px !important;
      }
    }
    li {
      position: relative;
      width: 16.666%;
      float: left;
      .zhuantitle {
        height: 24px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #272727;
        line-height: 24px;
        margin-top: 5px;
        margin-bottom: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .zhaungtijf {
        height: 21px;
        font-size: 16px;
        font-family: MicrosoftYaHei;
        color: #e53940;
        line-height: 21px;
      }
    }
  }
}
.fadein-enter-active {
  transition: all 0.3s;
}
.fadein-leave-to {
  transition: all 0.3s;
}
// .fadein-transition {
//   transition: all .3s ease-in;
// 	height: 256px;
// 	opacity: 1;
// 	overflow: hidden;
// }
.fadein-enter,
.fadein-leave-to {
  height: 0;
  opacity: 0;
}
header {
  background: #fff;
}
.sorTtitle {
  width: 138px;
  height: 46px;
  color: white;
  position: relative;
}
.navall {
  font-family: PingFangSC-Medium;
  font-weight: 500;
  display: inline-block;

  // width: 100%;
  font-size: 16px;
  font-weight: bold;
}
.navlist {
  height: 438px;
  box-sizing: border-box;
  overflow: hidden;
  overflow-y: auto;
  position: absolute;
  border-top: solid 1px #eee;
  top: 100px;
  background: #fff;
  width: 1200px;
  left: 50%;
  margin-left: -600px;
  z-index: 801;
  padding-left: 45px;
  padding-top: 40px;

  box-shadow: 0px 7px 12px 0px rgba(110, 110, 110, 0.42);
  li {
    height: 50px;
    line-height: 50px;
    background: #fff;
    text-align: left;
    // border-bottom: 1px dashed #e2e2e2;
    cursor: pointer;
    margin-bottom: 30px;
    font-size: 14px;
    font-family: SourceHanSansCN-Normal;
    float: left;
    width: 16.66%;
    box-sizing: border-box;
    padding: 0px 10px;
    a {
      img {
        width: 50px;
        height: 50px;
        margin-right: 20px;
        border-radius: 10px;
      }
      span {
        padding: 0px !important;
      }
    }
  }
  li:last-child {
    border: none;
  }
  a {
    display: block !important;
    border-bottom: 1px dashed #e2e2e2;
  }
  a:last-child {
    border-bottom: none;
  }
}
.navall:hover {
  .navlist {
    display: block !important;
  }
  // background:#000;
  // color: #fff !important;
}
.navall:hover #navlist {
  display: block !important;
}
.navlist:hover {
  display: block;
}
.nav1 {
  position: relative;
  &::before {
    content: "";
    position: absolute;
    left: -16px;
    top: 10px;
    width: 15px;
    height: 35px;
    background: linear-gradient(
      270deg,
      #eee 0%,
      rgba(235, 235, 235, 0.11) 99%,
      rgba(238, 238, 238, 0) 100%
    );
  }
}
.nav {
  height: 57px;
  line-height: 57px;

  ul {
    li {
      font-size: 16px;
      font-family: PingFangSC-Medium;
      font-weight: 400;
      // width: 123px;

      span {
        padding: 0px 15px;
        display: initial;
        position: relative;
        &:hover {
          color: #f83132;
        }
      }
      span:before {
        // content: "";
        // display: inline-block;
        // width: 1px;
        // height: 16px;
        // background: #ccc;
        // position: absolute;
        // left: 0px;
        // top: 4px;
      }

      span:hover {
        border-color: #ccc !important;
      }
    }
    li:first-child span:before {
      display: none;
    }
    li:first-child {
      margin-left: 20px;
    }
    li:nth-child(1) {
      span {
        border: 0;
      }
    }
  }
}
.common_nav_search {
  margin-left: 20px;
  position: relative;
  margin-top: 5px;
}
#search:focus {
  border-color: #f83132;
}
.common_nav_search .hot {
  padding-left: 0px;
  margin-top: 5px;
}
.common_nav_search input {
  width: 208px;
  height: 46px;
  padding-left: 15px;
  float: left;
  border: 1px solid #dbdbdb;
  font-size: 12px;
  line-height: 46px;
  box-sizing: border-box;
  border-radius: 3px;
  position: relative;
}
.common_nav_search input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px white inset !important;
}
.common_nav_search:hover {
  input {
    border: 1px solid #c1bbbb;
  }
  i {
    border-left: 1px solid #c1bbbb;
  }
}
.common_nav_search input + i {
  border-left: 1px solid #dbdbdb;
}
.common_nav_search input:focus + i,
.common_nav_search input:active + i {
  border-left: 1px solid #f83132 !important;
}
.common_nav_search i {
  transition: all 0.25s;
  //transition: all 1s ;
}

.common_nav_search_btn {
  width: 118px;
  height: 40px;
  font-size: 18px;
  font-weight: bold;
}

.common_nav_search i:hover {
  border-right: solid 1px #e31d1a !important ;
  background: #e31d1a;
  color: #fff !important;
  border-radius: 0px 3px 3px 0px;
}
</style>
<style scoped>
::-webkit-scrollbar {
  width: 10px;
  height: 2px;
  background: #eee; /*可以设置轨道颜色*/
  padding-right: 2px;
}
::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/common/nav.vue